/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../components/SmoothScroll";
const Accessibility = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
  <div>
      <title>
        Accessibility Commitment | Citrus Diagnostic Center,Florida 
      </title>
      <meta
        name="description"
        content="Our accessibility policy shows Citrus Diagnostic Center’s commitment to providing an inclusive, user-friendly digital experience for all patients and visitors."
      />
      <div className="flex justify-center items-center pt-48 lg:pt-[14.0625rem]">
      <div className="w-4/5  flex flex-col items-center  pb-8 lg:pb-16">
        <h1
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-[#d78558] font-robout lg:text-6xl text-center  md:text-5xl text-4xl pb-12 lg:pb-20 capitalize leading-tight sm:leading-snug font-black"
        >
          Accessibility Statement
        </h1>
        <div className="text-left">
          <p className="text-2xl pb-8 text-white md:text-left text-center">
            Effective Date: September 7, 2025
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 py-8 md:text-left text-center font-robout">
            <span className="text-[#ffffff]">Citrus Diagnostic Center </span> is
            committed to ensuring that our website and services are accessible
            to all patients, including individuals with disabilities. We strive
            to conform to the Web Content Accessibility Guidelines (WCAG) 2.1,
            Level AA and applicable requirements of the Americans with
            Disabilities Act (ADA).
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] md:text-left text-center font-bold lg:ps-0 md:px-8 px-4 py-10">
            Our Commitment
          </h2>
          <ul className="xl:text-[1.33rem] list-disc md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-8  text-left font-robout">
            <li>Website designed for patients of all abilities</li>
            <li>
              Regularly testing pages and features and addressing accessibility
              issues we discover or that are reported to us.
            </li>
            <li>
              Offering alternative access (phone scheduling and in-person
              assistance) if any part of our website is not fully accessible.
            </li>
          </ul>

          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold md:text-left text-center lg:ps-0 md:px-8 px-4 py-10">
            Ongoing Efforts
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white md:text-left text-center lg:ps-0 md:px-8 px-4 pb-4   font-robout">
            Accessibility is an ongoing effort. We are continually improving
            features and content to provide equal access to information and
            services for every patient.
          </p>

          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] md:text-left text-center font-bold lg:ps-0 md:px-8 px-4 pt-10">
            Need Help or Have Feedback?
          </h2>
          <h3 className="xl:text-[1.33rem] md:text-lg text-lg md:text-left text-center text-white py-10">
            If you experience difficulty using our website or need an accessible
            alternative, please contact us. We take feedback seriously and will
            make reasonable efforts to address concerns promptly.
          </h3>
          <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-8  text-left font-robout">
            <li>
              <span className="text-[#d78558]">Phone : </span>{" "}
              <a href="tel:3527959200"> (352) 450-8062</a>
            </li>
            <li>
              <span className="text-[#d78558]">Email : </span>{" "}
              <a href="mailto:info@citrusdiagnosticcenter.com">
                info@citrusdiagnosticcenter.com
              </a>
            </li>
            <li>
              <span className="text-[#d78558]">Address : </span>{" "}
              <a href="https://share.google/yVmeZoTlzXqwnAFvJ">
                922 N Citrus Ave, Crystal River, FL 34428
              </a>
            </li>
          </ul>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] md:text-left text-center font-bold lg:ps-0 md:px-8 px-4 py-5">
            Alternative Access
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white md:text-left text-center lg:ps-0 md:px-8 px-4 pb-4  font-robout">
            All patients may reach us by phone or in person for information
            about imaging services, scheduling, preparation instructions, and
            billing support.
          </p>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Accessibility;
